import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  CreateContractsMutation,
  CreateContractsMutationVariables
} from './__generated__/CreateContractsMutation'
import { contractFragment } from '../fragments/ContractFragment'

const mutation: TypedDocumentNode<
  CreateContractsMutation,
  CreateContractsMutationVariables
> = gql`
  ${contractFragment}

  mutation CreateContractsMutation($input: CreateContractsInput!) {
    createContracts(input: $input) {
      contracts {
        ...ContractFragment
      }
    }
  }
`

export function createContractsMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      CreateContractsMutation,
      CreateContractsMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
